const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3041/v1';

export async function listExperiences(query = '') {
  const url = `${API_BASE}/experiences${query ? `?${query}` : ''}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error('Failed to load experiences');
  const data = await res.json();
  // data may be paginated { results, ... } or an array
  if (Array.isArray(data)) {
    return data;
  }
  if (data && data.results) {
    return data.results;
  }
  return [];
}

export async function getExperience(id: string) {
  const res = await fetch(`${API_BASE}/experiences/${id}`);
  if (!res.ok) throw new Error('Failed to get experience');
  return res.json();
}

export async function createExperience(payload: any) {
  const res = await fetch(`${API_BASE}/admin/experiences`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('admin_token')}` },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error('Failed to create');
  return res.json();
}

export async function updateExperience(id: string, payload: any) {
  const res = await fetch(`${API_BASE}/admin/experiences/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('admin_token')}` },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error('Failed to update');
  return res.json();
}

export async function deleteExperience(id: string) {
  const res = await fetch(`${API_BASE}/admin/experiences/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` },
  });
  if (!res.ok) throw new Error('Failed to delete');
  try {
    return await res.json();
  } catch (e) {
    return null;
  }
}

export default {
  listExperiences,
  getExperience,
  createExperience,
  updateExperience,
  deleteExperience,
};
